import Nullstack from 'nullstack';
export default function IconCurrencyTaka({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-taka",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "16.5",
    cy: "15.5",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 11h6"
  }), " ");
}